import { Formik, Form } from 'formik'
import React, { Component } from 'react'
import { APIURL } from '../../../src/hoc/AxiosSetting/axios';
import axios from 'axios';
import moment from 'moment';

export default class ViewObservationsurveillanceTwo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   auditplanurl: "",

            reportOfObservation: {
                orgCode: props.match.params.orgcode,
                observationurl: "",
            },
            editStatus: false,
            showMessage: false,

            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: false,
            isLoading:false
        }
        this.viewObservationUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }


    // handleRoute = () => {
    //     window.location.href = "/" + localStorage.getItem("role") + '/updatesurveillanceobservation/' + this.state.reportOfObservation.orgCode;
    // }


    componentDidMount() {
        const api=APIURL + '/api/survillanceTwo/get/surveillancetwodata/' + this.state.reportOfObservation.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                if (res.data.errorCode === 0) {
                    console.log("Surviellance response", res.data.response)
                    this.setState({ data: res.data.response })
                    this.setState({ editStatus: true })

                    // if(res.data.response.auditteamproposalStatus  && res.data.response.auditPlanStatus)
                    // {
                    //     this.setState({editStatus:true})
                    //     if ( this.state.data.auditplanurl) {
                    //         this.setState({ uploadedProcessUrl: this.state.data.auditplanurl })
                    //         this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none" })
                    //     }
                    //     else if (! this.state.data.auditplanurl) {
                    //         this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block" })
                    //     }
                    // } else if(res.data.response.auditteamproposalStatus && !res.data.response.auditPlanStatus)
                    // {
                    //     this.setState({editStatus:true,message:"Need to Fill the Audit Plan Data",showMessage:true})
                    // } else{
                    //     this.setState({ editStatus: false , message:"This Company's Audit Team Proposal data not filled.",showMessage:true})
                    // }
                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                   // alert("if")
                    this.setState({isLoading:true})
                }
            })

    }
    render() {
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <Formik
                    enableReinitialize={true}
                // initialValues={initialValues}
                // onSubmit={onSubmit}
                >
                    {formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body" style={{ paddingLeft: "50px" }}>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Organization</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.orgName}</p>

                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Surveillance Type</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.surveillanceTypeName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.address}</p>
                                                            </div>
                                                        </div>


                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">File  No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.fileno}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Report No</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.reportno}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Site Address (If any)</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.siteofaddress}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Employees</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.effectiveNoEmpToBeAudited}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Email id </label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.email}</p>
                                                            </div>
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact Person </label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.contactPersonName}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Telephone/Fax</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.mobile}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">ANZSIC Code / NACE CODE</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.nabcbcodeName}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope </label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.scope}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-3">
                                                            <div className="col-sm-7 text-dark">
                                                                <label>Non applicable requirements as determined by organisation: </label>
                                                            </div>
                                                            <div className="col-sm-5">
                                                                <p>All Clauses are applicable</p>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="row">
                                                                    <label htmlFor="staticEmail" className="col-sm-7 labelsize">Justification for Non applicability checked and accepted?</label>
                                                                    <div className="col-sm-5">
                                                                        <p>{this.state.data.gpPvtHealthSubCenterOptions}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <div className="row">
                                                                    <label htmlFor="staticEmail" className="col-sm-7 labelsize">Type Of Audit</label>
                                                                    <div className="col-sm-5">
                                                                        <p>{this.state.data.typeofaudit}</p>
                                                                    </div>
                                                                </div>
                                                                <p className="mt-4"><b>Note: </b><i>Combined/Joint/integrated audit(If Applicable) </i></p>

                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Significant Changes(if any),Since last audit that affects QMS</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.significantchanges}</p>
                                                            </div>


                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.teamleaderName}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical Expert</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.technicalExpertName}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Observation Date:</label>
                                                            <div className="col-sm-3 mt-2" >
                                                                <p> {moment(this.state.data.datestage2observation).format("DD-MMM-YYYY")}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Place of the Audit</label>
                                                            <div className="col-sm-3">
                                                                <p></p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any Deviation in the Audit Plan and Reason(if any) </label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.anydeviationinauditplan}</p>
                                                            </div>


                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Brief about the organization </label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.briefaboutorg}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any Significant issue impacting on the Audit Programme</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.anysignificantissue}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Any unresolved issues(if identified)</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.anyunresolved}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Criteria of Audit(Disclaimer Statement)</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.criteriaofaudit}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Objective of Audit</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.objectiveofaudit}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Verification of effectiveness of NC closure of Stage 1 Audit(If any)</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.verificationofeffectiveness}</p>
                                                            </div>
                                                        </div>

                                                        <hr />
                                                        <div className="row mt-2">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">External Issues</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.externalissues}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-2">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Internal Issues</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.internalissues}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-2">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Needs and Expectations of interested parties</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.needsandexpectations}</p>
                                                            </div>
                                                        </div>


                                                        <div className="row mt-2">
                                                            <label htmlFor="staticEmail" className="col-sm-6 labelsize">Risk & Opportunity & Change Control</label>
                                                            <div className="col-sm-12">
                                                                <p>{this.state.data.riskandopportunity}</p>

                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">Audit Findings</label>
                                                            {
                                                                this.state.data && this.state.data.processAuditReportDetails && this.state.data.processAuditReportDetails.length > 0 ?
                                                                    this.state.data.processAuditReportDetails.map((item, index) => {
                                                                        return (
                                                                            <div className="mt-4">
                                                                                <table key={index}>
                                                                                    <tr >
                                                                                        <td style={{ width: "20%" }}> Name Of Process </td>
                                                                                        <td>{item.nameofprocess}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: "20%" }}>Process Owner </td>
                                                                                        <td>{item.processowner}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: "20%" }} >Reference</td>
                                                                                        <td colSpan="3">{item.reference}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: "20%" }}>Details</td>
                                                                                        <td colSpan="3" dangerouslySetInnerHTML={{ __html: item.details }}></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td style={{ width: "20%" }}>Auditor comments on</td>
                                                                                        <td colSpan="3">{item.comments}</td>



                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>Clauses Details</td>
                                                                                        <td colSpan="3">


                                                                                            <table className="table ">
                                                                                                <thead >
                                                                                                    <tr>

                                                                                                        <td scope="col" className="text-center" style={{ "width": "180px" }}>Clause </td>
                                                                                                        <td scope="col" className="text-center" style={{ "width": "120px" }}> Observation</td>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                {
                                                                                                    item.clauseWiseObservation ?
                                                                                                        item.clauseWiseObservation.map((subitem, subindex) => {
                                                                                                            return (
                                                                                                                <tbody key={subindex}>


                                                                                                                    <tr>
                                                                                                                        <td style={{ "width": "60px" }}>{subitem.clauseNo}</td>
                                                                                                                        <td style={{ "width": "120px" }}>{subitem.Observation}</td>


                                                                                                                    </tr>

                                                                                                                </tbody>
                                                                                                            )
                                                                                                        })
                                                                                                        :
                                                                                                        <>No Nace Code data addded</>
                                                                                                }
                                                                                            </table>



                                                                                        </td>



                                                                                    </tr>

                                                                                </table>
                                                                                <br />

                                                                            </div>
                                                                        )
                                                                    }
                                                                    ) : <>No Data Found</>
                                                            }
                                                        </div>
                                                        <div className="hrstyle">
                                                            <h5>A. Summary</h5>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Observations</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.obervations}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Opportunities for Improvement </label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.opportunitiesforimprovment}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Positive Findings</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.positivefindingsSurveillance}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">NC Statement(if any)</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.ncstatementifany}</p>
                                                            </div>
                                                        </div>
                                                        <div className="hrstyle">
                                                            <h5>B. Recommendation</h5>
                                                        </div>
                                                        <div className="row mt-4">

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Select Recommendation</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.recommendationType}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Report submission Date</label>
                                                            <div className="col-sm-3">
                                                                <p>{moment(this.state.data.reportsubdate).format("DD-MMM-YYYY")}</p>

                                                            </div>
                                                        </div>
                                                        <div className="hrstyle">
                                                            <h5>IQCPL Report Submission</h5>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of Auditor</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.nameofauditor}</p>
                                                            </div>
                                                        </div>
                                                        <div className="hrstyle">
                                                            <h5>Client Acceptance for Report </h5>
                                                        </div>
                                                        <div className="row mt-4">

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.clientname}</p>
                                                            </div>

                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Designation</label>
                                                            <div className="col-sm-3">
                                                                <p>{this.state.data.clientdesignation}</p>

                                                            </div>
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                                    <h5>C. Surveillance Audit Review-Technical Team(For office use only)</h5>
                                                        </div>
                                                        <div className='mt-3' style={{marginLeft:"1%"}}><h6>Technical Review</h6></div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Changes (if any) in  Scope Statement against NACE code</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceOneremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Exclusion and Justification adequate</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceTworemark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Has Auditor covered all the applicable Clauses (Surveillance Audit)</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceThreeremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Evidences are appropriate</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceFourremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">NC statement and its clause ref</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceFiveremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Verification of Corrective actions and Evidence</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceSixremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Acceptance of Surveillance Audit Report</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.survellianceSevenremark}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditors Comments In case of major Non-Conformities/withdraw/Repeat audit</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.auditorcommentnoncon}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical Reviewer Comment/Remark</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.techreviewercomment}</p>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">CDC Review Comments (Comments on Continuation/Withdraw/Repeat Audit)</label>
                                                            <div className="col-sm-9">
                                                                <p>{this.state.data.cdcreviewremark}</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        {/* {
                            localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" || localStorage.getItem("userRole") === "Executive(Support)" ?
                                ""
                                :
                                <div className="card-footer">
                                    <div className="row">
                                        <div className="col-sm-10"></div>
                                        <div className="col-sm-2">
                                            {this.state.editStatus ?
                                                <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>
                                                : <></>
                                            }
                                        </div>

                                    </div>
                                </div>
                        } */}
                    </Form>
                    }
                </Formik>
            </div>
        )
    }
}